export const storageConstant = {
  LOCALSTORAGE: 'local-storage',
  SESSIONSTORAGE: 'session-storage',

  SEARCH_DATA: 'CollegeSearchData',
  LOGIN_INFO: 'loginInfo',
  FROM_REGISTER_PAGE: 'FromRegisterPage',
  NEW_REGISTER_USER: 'NewRegisterUser',
  USER: 'user',
  REVIEW_DATA_INFO: 'ReviewDataInfo',
  EXISTING_COLLEGE_REVIEW: 'ExistCollegeReviewList',
  FROM_REVIEW_PAGE: 'FromReviewCollegePage',
  MAJORDATA: 'majorData',
  SELECTED_STATE: 'selectedstate',
  FILTERDATA: 'filterdata',
  MAJOR_LEVEL: 'majorLevel',
  COLLAPSE_OPEN: 'collapseOpen',
  COLLEGE_SEARCH_DATA: 'CollegeSearchData',
  REGISTER_C_INFO: 'RegisterCinfo',
  SECONDARY_SOURCE: 'SecondarySource',
  UPDATE_PHONE: 'update_phone',
  SCHOLARSHIPS: 'open_scholarship',
  UPDATE_DISABILITY: 'update_disability',
  INSURANCE_AMOUNT: 'InsuranceAmount',
  STUDENT_LOAN_CALC_AMOUNT: 'StudentLoanCalculatorAmount',
  LOGGED_IN_USER: 'loggedInUser',
  LOGGED_IN_TOKEN: 'loggedInToken',
  FROM_PARTNER_CONTACT_WIDGET: 'FromPartnerWidget',
  /** Flash toast shown on /login after password or email change forces logout */
  POST_LOGOUT_TOAST: 'postLogoutToast',
}